import React from "react";
import {checkReplaceUrl} from '../../utils'

export const ListingCard = ({ data }) => {
  const getTextContent = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
  };
  const createMarkup = () => {
    if(Array.isArray(data?.description)){
      return <p className=" sd-font-pilat sd-mb-[10px]">{data?.description[0]}</p>
    }
    else{
      let temp=getTextContent(data?.description)
      return<p className="sd-font-pilat sd-mb-[10px]">
        {temp}
      </p>
      
    }
  }

  return (
    <React.Fragment>
      <li className="sd-cols-span-14 sm:sd-cols-span-10 sm:sd-offs-1  sd-list-reset lg:sd-mb-[48px] sd-mb-[36px] lg:sd-mb-[64px]">
        <article className="sd-flex sd-flex-col ">
          <div className="sd-mb-2 ">
            {data?.contentType && (
              <span className="sd-bg-black sd-p-2 sd-m-2 sd-text-xs sd-font-semibold sd-uppercase sd-text-white first:sd-ml-0">
                {data.contentType}
              </span>
            )}
            {data.filterSubDocumentType?.[0] && (
              <span className="sd-bg-black sd-p-2 sd-text-xs sd-font-semibold sd-uppercase sd-text-white sd-w-fit">
                {data.filterSubDocumentType[0]?.length === 1 ? data.filterSubDocumentType : data.filterSubDocumentType[0]}
              </span>
            )}
          </div>
          <a
            href={checkReplaceUrl(data.url)}
            target="_blank"
            title={data.title[0]}
            className="sd-pt-[14px] sd-pb-[10px]" rel="noreferrer"
          >
            <h3 className="sd-text-[1.375rem]">{data.title?.[0]?.length < 2 ? data.title : data.title?.[0]}</h3>
            
          </a>
          {/* {JSON.stringify(data.description)} */}
          {/* <div className="sd-font-pilat"
            dangerouslySetInnerHTML={createMarkup()}
          > */}
          {/* </div> */}
          {createMarkup()}
          <a
            href={checkReplaceUrl(`${data.url}`)}
            target="_blank"
            className="sd-word-wrap sd-underline hover:sd-no-underline" rel="noreferrer"
          >
            {checkReplaceUrl(`${data.url}`)}
          </a>
        </article>
      </li>
    </React.Fragment>
  )



};

export default ListingCard;

